"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jstz = require('jstz');
var us = require('us');
module.exports.browserLocale = browserLocale;
module.exports.browserTimezone = browserTimezone;
module.exports.inTimezone = inTimezone;
/**
 * Returns whether or not the current user is in the timezone of the given region. Currently only supports US states.
 * @param region A string representation of a region, i.e. 'CA'
 */
function inTimezone(region) {
    var timezone = browserTimezone();
    if (!timezone) {
        return false;
    }
    var usState = us.lookup(region);
    if (usState) {
        return timezone === us.lookup(region).capital_tz;
    }
    return false;
}
exports.inTimezone = inTimezone;
function browserTimezone() {
    if (!window) {
        return;
    }
    var timezone = jstz.determine();
    return timezone.name();
}
exports.browserTimezone = browserTimezone;
function browserLocale() {
    if (!window || !navigator) {
        return;
    }
    if (window.navigator && window.navigator.languages && window.navigator.languages.length > 0) {
        // Latest versions of Chrome and Firefox set this correctly
        return navigator.languages[0];
    }
    if (navigator.userLanguage) {
        // IE only
        return navigator.userLanguage;
    }
    return navigator.language;
}
exports.browserLocale = browserLocale;
